import React from 'react';

const Footer = () => {
  return (
    <footer id="contact" className="bg-gradient-to-br from-primary-800 via-primary-900 to-primary-950 text-white py-10 relative overflow-hidden">
      {/* Decorative background elements */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
      </div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid md:grid-cols-2 gap-6 lg:gap-8 mb-8">
          {/* Company Info - Left Side */}
          <div className="md:col-span-1">
            <div className="flex flex-col items-start mb-6">
              <div className="flex items-center gap-3 mb-4">
                <img 
                  src="/logo.png" 
                  alt="Shravi Finance Logo" 
                  className="h-20 sm:h-24 md:h-28 w-auto"
                />
                <div>
                  <h3 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white leading-tight mb-1">Shravi Financial Services</h3>
                  <p className="text-white/80 text-xs sm:text-sm">Your Trusted Financial Partner</p>
                </div>
              </div>
              <p className="text-white/80 mb-4 leading-relaxed text-sm sm:text-base max-w-md">
                Your trusted partner for all your financial needs. We make loans simple, fast, and accessible.
              </p>
              <div className="flex space-x-3">
                <a href="https://www.facebook.com/profile.php?id=61565025146781" target="_blank" rel="noopener noreferrer" className="bg-white/10 hover:bg-white/20 rounded-full p-2.5 transition-all transform hover:scale-110">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                  </svg>
                </a>
              
                <a href="https://www.instagram.com/shraviifinance/" target="_blank" rel="noopener noreferrer" className="bg-white/10 hover:bg-white/20 rounded-full p-2.5 transition-all transform hover:scale-110">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793-.001 1.44.645 1.44 1.439z"/>
                  </svg>
                </a>
              </div>
            </div>
          </div>

          {/* Links and Contact - Right Side */}
          <div className="md:col-span-1 grid sm:grid-cols-2 gap-6">
            {/* Quick Links */}
            <div>
              <h4 className="text-lg font-bold mb-4 text-white">Quick Links</h4>
              <ul className="space-y-2">
                <li>
                  <a href="#home" className="text-white/90 hover:text-white transition-colors flex items-center group text-base">
                    <span className="w-2.5 h-2.5 bg-gold-500 rounded-full mr-3 group-hover:bg-gold-400 transition-colors flex-shrink-0 shadow-[0_0_0_3px_rgba(245,158,11,0.15)]"></span>
                    <span>Home</span>
                  </a>
                </li>
                <li>
                  <a href="#services" className="text-white/90 hover:text-white transition-colors flex items-center group text-base">
                    <span className="w-2.5 h-2.5 bg-gold-500 rounded-full mr-3 group-hover:bg-gold-400 transition-colors flex-shrink-0 shadow-[0_0_0_3px_rgba(245,158,11,0.15)]"></span>
                    <span>Services</span>
                  </a>
                </li>
                <li>
                  <a href="#faq" className="text-white/90 hover:text-white transition-colors flex items-center group text-base">
                    <span className="w-2.5 h-2.5 bg-gold-500 rounded-full mr-3 group-hover:bg-gold-400 transition-colors flex-shrink-0 shadow-[0_0_0_3px_rgba(245,158,11,0.15)]"></span>
                    <span>FAQ</span>
                  </a>
                </li>
                <li>
                  <a href="#contact" className="text-white/90 hover:text-white transition-colors flex items-center group text-base">
                    <span className="w-2.5 h-2.5 bg-gold-500 rounded-full mr-3 group-hover:bg-gold-400 transition-colors flex-shrink-0 shadow-[0_0_0_3px_rgba(245,158,11,0.15)]"></span>
                    <span>Contact</span>
                  </a>
                </li>
                <li>
                  <a 
                    href="#/privacy-policy" 
                    onClick={(e) => {
                      e.preventDefault();
                      window.location.hash = '#/privacy-policy';
                      setTimeout(() => window.scrollTo({ top: 0, behavior: 'smooth' }), 100);
                    }}
                    className="text-white/90 hover:text-white transition-colors flex items-center group text-base"
                  >
                    <span className="w-2.5 h-2.5 bg-gold-500 rounded-full mr-3 group-hover:bg-gold-400 transition-colors flex-shrink-0 shadow-[0_0_0_3px_rgba(245,158,11,0.15)]"></span>
                    <span>Privacy Policy</span>
                  </a>
                </li>
                <li>
                  <a 
                    href="#/terms-conditions" 
                    onClick={(e) => {
                      e.preventDefault();
                      window.location.hash = '#/terms-conditions';
                      setTimeout(() => window.scrollTo({ top: 0, behavior: 'smooth' }), 100);
                    }}
                    className="text-white/90 hover:text-white transition-colors flex items-center group text-base"
                  >
                    <span className="w-2.5 h-2.5 bg-gold-500 rounded-full mr-3 group-hover:bg-gold-400 transition-colors flex-shrink-0 shadow-[0_0_0_3px_rgba(245,158,11,0.15)]"></span>
                    <span>Terms & Conditions</span>
                  </a>
                </li>
                <li>
                  <a 
                    href="#/disclosures" 
                    onClick={(e) => {
                      e.preventDefault();
                      window.location.hash = '#/disclosures';
                      setTimeout(() => window.scrollTo({ top: 0, behavior: 'smooth' }), 100);
                    }}
                    className="text-white/90 hover:text-white transition-colors flex items-center group text-base"
                  >
                    <span className="w-2.5 h-2.5 bg-gold-500 rounded-full mr-3 group-hover:bg-gold-400 transition-colors flex-shrink-0 shadow-[0_0_0_3px_rgba(245,158,11,0.15)]"></span>
                    <span>Disclosures & Compliance</span>
                  </a>
                </li>
              </ul>
            </div>

            {/* Services */}
            <div>
              <h4 className="text-lg font-bold mb-4 text-white">Our Services</h4>
              <ul className="space-y-2">
                <li>
                  <a href="#services" className="text-white/90 hover:text-white transition-colors flex items-center group text-base">
                    <span className="w-2.5 h-2.5 bg-gold-500 rounded-full mr-3 group-hover:bg-gold-400 transition-colors flex-shrink-0 shadow-[0_0_0_3px_rgba(245,158,11,0.15)]"></span>
                    <span>Personal Loans</span>
                  </a>
                </li>
                <li>
                  <a href="#services" className="text-white/90 hover:text-white transition-colors flex items-center group text-base">
                    <span className="w-2.5 h-2.5 bg-gold-500 rounded-full mr-3 group-hover:bg-gold-400 transition-colors flex-shrink-0 shadow-[0_0_0_3px_rgba(245,158,11,0.15)]"></span>
                    <span>Home Loans</span>
                  </a>
                </li>
                <li>
                  <a href="#services" className="text-white/90 hover:text-white transition-colors flex items-center group text-base">
                    <span className="w-2.5 h-2.5 bg-gold-500 rounded-full mr-3 group-hover:bg-gold-400 transition-colors flex-shrink-0 shadow-[0_0_0_3px_rgba(245,158,11,0.15)]"></span>
                    <span>Business Loans</span>
                  </a>
                </li>
                <li>
                  <a href="#services" className="text-white/90 hover:text-white transition-colors flex items-center group text-base">
                    <span className="w-2.5 h-2.5 bg-gold-500 rounded-full mr-3 group-hover:bg-gold-400 transition-colors flex-shrink-0 shadow-[0_0_0_3px_rgba(245,158,11,0.15)]"></span>
                    <span>Vehicle Loans</span>
                  </a>
                </li>
                <li>
                  <a href="#services" className="text-white/90 hover:text-white transition-colors flex items-center group text-base">
                    <span className="w-2.5 h-2.5 bg-gold-500 rounded-full mr-3 group-hover:bg-gold-400 transition-colors flex-shrink-0 shadow-[0_0_0_3px_rgba(245,158,11,0.15)]"></span>
                    <span>Education Loans</span>
                  </a>
                </li>
                <li>
                  <a href="#services" className="text-white/90 hover:text-white transition-colors flex items-center group text-base">
                    <span className="w-2.5 h-2.5 bg-gold-500 rounded-full mr-3 group-hover:bg-gold-400 transition-colors flex-shrink-0 shadow-[0_0_0_3px_rgba(245,158,11,0.15)]"></span>
                    <span>Gold Loans</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* Contact Info - Full Width Below */}
          <div className="md:col-span-2 mt-6 pt-6 border-t border-white/10">
            <h4 className="text-lg font-bold mb-4 text-white">Contact Us</h4>
            <div className="grid sm:grid-cols-3 gap-4 mb-6">
              <div className="flex items-start">
                <div className="bg-white/20 rounded-lg p-2.5 mr-3 flex-shrink-0">
                  <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                </div>
                <div>
                  <p className="text-white/80 text-xs mb-1.5 font-medium">Phone</p>
                  <a
                    href="https://wa.me/917058186808?text=Hello%20Shravi%20Finance%2C%20I%20want%20to%20apply%20for%20a%20loan."
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-0.5 flex items-center gap-2 text-white font-semibold text-sm leading-snug hover:text-white/90 transition-colors"
                  >
                    <span className="bg-[#25D366] rounded-md p-1 flex-shrink-0">
                      <svg className="w-4 h-4" fill="white" viewBox="0 0 24 24" aria-hidden="true">
                        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 23l5.25-1.38a11.767 11.767 0 005.743 1.494h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
                      </svg>
                    </span>
                    <span>+91 7058186808</span>
                  </a>
                  <a
                    href="https://wa.me/918668272248?text=Hello%20Shravi%20Finance%2C%20I%20want%20to%20apply%20for%20a%20loan."
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-2 text-white font-semibold text-sm leading-snug hover:text-white/90 transition-colors"
                  >
                    <span className="bg-[#25D366] rounded-md p-1 flex-shrink-0">
                      <svg className="w-4 h-4" fill="white" viewBox="0 0 24 24" aria-hidden="true">
                        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 23l5.25-1.38a11.767 11.767 0 005.743 1.494h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
                      </svg>
                    </span>
                    <span>+91 8668272248</span>
                  </a>
             
                </div>
              </div>
              <div className="flex items-start">
                <div className="bg-white/20 rounded-lg p-2.5 mr-3 flex-shrink-0">
                  <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                </div>
                <div>
                  <p className="text-white/80 text-xs mb-1.5 font-medium">Email</p>
                  <a
                    href="mailto:shravifinance@gmail.com"
                    className="text-white font-semibold text-sm break-words hover:text-white/90 transition-colors"
                  >
                    shravifinance@gmail.com
                  </a>
                </div>
              </div>
              <div className="flex items-start">
                <div className="bg-white/20 rounded-lg p-2.5 mr-3 flex-shrink-0">
                  <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                </div>
                <div>
                  <p className="text-white/80 text-xs mb-1.5 font-medium">Address</p>
                  <p className="text-white font-semibold text-xs leading-relaxed">2nd Floor, 157/116, Beside Shri Krishna Mandir, Opp. Techops Grand, Ayodhya Nagar Rd, Chakradhar Nagar, Nagpur – 440024</p>
                  <p className="text-white/90 text-xs mt-1.5">
                    <strong>Working Hours:</strong> 10:30 AM – 7:00 PM (IST)
                  </p>
                </div>
              </div>
            </div>

            {/* RBI Regulatory Links */}
            <div className="bg-white/10 rounded-lg p-6 border border-white/20">
              <h4 className="text-lg font-bold mb-4 text-white">Regulatory & Consumer Protection (RBI)</h4>
              <div className="grid sm:grid-cols-2 gap-3" style={{ fontSize: '13px' }}>
                <a 
                  href="https://www.rbi.org.in/commonman/english/scripts/FAQs.aspx?Id=3413" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-white/90 hover:text-white hover:underline transition-colors flex items-center gap-2"
                >
                  <span className="text-yellow-400">→</span>
                  <span>RBI Digital Lending FAQs</span>
                </a>
                <a 
                  href="https://www.rbi.org.in/commonman/english/Scripts/Notification.aspx?Id=1572" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-white/90 hover:text-white hover:underline transition-colors flex items-center gap-2"
                >
                  <span className="text-yellow-400">→</span>
                  <span>Fair Practices Code</span>
                </a>
                <a 
                  href="https://www.rbi.org.in/commonman/english/Scripts/Notification.aspx?Id=867" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-white/90 hover:text-white hover:underline transition-colors flex items-center gap-2"
                >
                  <span className="text-yellow-400">→</span>
                  <span>Master Circular – FPC</span>
                </a>
                <a 
                  href="https://sachet.rbi.org.in/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-white/90 hover:text-white hover:underline transition-colors flex items-center gap-2"
                >
                  <span className="text-yellow-400">→</span>
                  <span>RBI Sachet Portal</span>
                </a>
                <a 
                  href="https://cms.rbi.org.in" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-white/90 hover:text-white hover:underline transition-colors flex items-center gap-2 sm:col-span-2"
                >
                  <span className="text-yellow-400">→</span>
                  <span>RBI Complaint Management System</span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <p className="text-white/50 text-xs" style={{ fontSize: '12px' }}>
            Prajwal Jadhav and Nikita Bansod / Shravi Finance - Authorised DSA for RBI-regulated banks and NBFCs
          </p>
        <div className="border-t border-white/10 mt-6 pt-4 text-center">
          <p className="text-white/60 text-xs sm:text-sm mb-2">
            &copy; {new Date().getFullYear()} Shravi Finance. All rights reserved.
          </p>
        
     
          <p className="text-white/60 text-xs sm:text-sm mb-2">
            Designed & Developed with ❤️ by ClarityX.in
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

